<section
  class="overflow-hidden rounded-2xl border border-slate-200 bg-white text-slate-950 shadow-[0_10px_30px_rgba(15,23,42,0.05)]"
  aria-labelledby="dispatch-freight-heading"
>
  <header class="flex flex-wrap items-center justify-between gap-3 border-b border-slate-200 px-4 py-3.5 sm:px-5">
    <div class="min-w-0">
      <div class="flex items-baseline gap-2">
        <h3 id="dispatch-freight-heading" class="m-0 text-base font-black tracking-tight text-slate-950">
          Freight
        </h3>
        <span *ngIf="internalDraft.items.length" class="text-xs font-semibold text-slate-500">
          {{ internalDraft.items.length }} {{ internalDraft.items.length === 1 ? 'item' : 'items' }}
        </span>
      </div>
      <p class="mb-0 mt-1 truncate text-xs text-slate-500">
        {{ originLabel }} <span aria-hidden="true">&rarr;</span> {{ destinationLabel }}
      </p>
    </div>

    <div *ngIf="mode === 'edit' && internalDraft.items.length > 0" class="flex flex-wrap items-center gap-2">
      <button
        type="button"
        class="min-h-10 rounded-lg border border-slate-300 bg-white px-3 py-2 text-xs font-bold text-slate-700 transition hover:border-blue-400 hover:bg-blue-50 hover:text-blue-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
        (click)="addCatalogLine()"
      >
        Add customer product
      </button>
      <button
        type="button"
        class="min-h-10 rounded-lg bg-blue-600 px-3 py-2 text-xs font-bold text-white shadow-sm transition hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
        (click)="addManualLine()"
      >
        Add custom package
      </button>
    </div>
  </header>

  <div class="space-y-4 p-4 sm:p-5">
    <div
      *ngIf="internalDraft.items.length === 0"
      class="rounded-xl border border-dashed border-slate-300 bg-slate-50 px-5 py-7 text-center"
    >
      <h4 class="m-0 text-sm font-black text-slate-900">No freight added</h4>
      <p class="mb-0 mt-1 text-xs text-slate-500">
        Choose a saved customer product or enter a custom package.
      </p>
      <div *ngIf="mode === 'edit'" class="mt-4 flex flex-col justify-center gap-2 sm:flex-row">
        <button
          type="button"
          class="min-h-10 rounded-lg border border-slate-300 bg-white px-4 py-2 text-xs font-bold text-slate-700 transition hover:border-blue-400 hover:bg-blue-50 hover:text-blue-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
          (click)="addCatalogLine()"
        >
          Add customer product
        </button>
        <button
          type="button"
          class="min-h-10 rounded-lg bg-blue-600 px-4 py-2 text-xs font-bold text-white shadow-sm transition hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
          (click)="addManualLine()"
        >
          Add custom package
        </button>
      </div>
    </div>

    <div *ngIf="internalDraft.items.length > 0" class="overflow-x-auto rounded-xl border border-slate-200">
      <table class="w-full min-w-[900px] border-collapse text-left text-xs">
        <thead class="bg-slate-50 text-[10px] uppercase tracking-[0.12em] text-slate-500">
          <tr>
            <th class="w-10 px-3 py-2.5 font-black">#</th>
            <th class="min-w-56 px-3 py-2.5 font-black">Item</th>
            <th class="w-20 px-3 py-2.5 font-black">Qty</th>
            <th class="min-w-64 px-3 py-2.5 font-black">Size</th>
            <th class="w-40 px-3 py-2.5 font-black">Weight</th>
            <th class="min-w-44 px-3 py-2.5 font-black">Handling</th>
            <th *ngIf="mode === 'edit'" class="w-20 px-3 py-2.5 text-right font-black">&nbsp;</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-200 bg-white">
          <tr *ngFor="let line of internalDraft.items; let i = index; trackBy: trackLine" class="align-top hover:bg-slate-50/70">
            <td class="px-3 py-3">
              <span class="inline-grid h-6 min-w-6 place-items-center rounded-md bg-slate-100 px-1 text-[10px] font-black text-slate-600">
                {{ i + 1 }}
              </span>
              <span *ngIf="showValidation && lineIssueCount(i)" class="mt-1 block text-[10px] font-bold text-rose-700">
                Check item
              </span>
            </td>

            <td class="px-3 py-3">
              <span class="mb-1.5 block text-[10px] font-black uppercase tracking-[0.12em]" [class.text-blue-700]="line.source === 'catalog'" [class.text-violet-700]="line.source === 'manual'">
                {{ line.source === 'catalog' ? 'Customer product' : 'Custom package' }}
              </span>
              <ng-container *ngIf="line.source === 'manual'">
                <input
                  *ngIf="mode === 'edit'"
                  class="df-input w-full"
                  type="text"
                  placeholder="Description or model"
                  [value]="manualLine(line).label"
                  (input)="updateLineString(i, 'label', $event)"
                  [attr.aria-label]="'Description for freight item ' + (i + 1)"
                >
                <span *ngIf="mode === 'rate'" class="block break-words font-semibold text-slate-800">
                  {{ manualLine(line).label || 'Custom package' }}
                </span>
              </ng-container>
              <ng-container *ngIf="line.source === 'catalog'">
                <input
                  *ngIf="mode === 'edit'"
                  class="df-input w-full font-mono"
                  type="text"
                  placeholder="Customer product ID"
                  [class.df-input-invalid]="showValidation && hasIssue('freight_items.' + i + '.customer_product_uuid')"
                  [attr.aria-invalid]="showValidation && hasIssue('freight_items.' + i + '.customer_product_uuid') ? 'true' : null"
                  [value]="catalogLine(line).customer_product_uuid"
                  (input)="updateLineString(i, 'customer_product_uuid', $event)"
                  [attr.aria-label]="'Customer product for freight item ' + (i + 1)"
                >
                <span *ngIf="mode === 'rate'" class="block break-all font-mono text-[11px] text-slate-700">
                  {{ catalogLine(line).customer_product_uuid || 'Product not selected' }}
                </span>
              </ng-container>
            </td>

            <td class="px-3 py-3">
              <input
                *ngIf="mode === 'edit'"
                class="df-input w-16"
                type="number"
                min="1"
                step="1"
                [class.df-input-invalid]="showValidation && hasIssue('freight_items.' + i + '.package_quantity')"
                [attr.aria-invalid]="showValidation && hasIssue('freight_items.' + i + '.package_quantity') ? 'true' : null"
                [value]="line.package_quantity ?? ''"
                (input)="updateLineNumber(i, 'package_quantity', $event)"
                [attr.aria-label]="'Quantity for freight item ' + (i + 1)"
              >
              <span *ngIf="mode === 'rate'" class="font-semibold">{{ line.package_quantity ?? '—' }}</span>
            </td>

            <td class="px-3 py-3">
              <ng-container *ngIf="line.source === 'manual'; else catalogSize">
                <div *ngIf="mode === 'edit'" class="grid grid-cols-3 gap-1.5">
                  <input class="df-input min-w-0" type="number" min="0" step="any" placeholder="L" [class.df-input-invalid]="showValidation && hasIssue('freight_items.' + i + '.length')" [value]="manualLine(line).length ?? ''" (input)="updateLineNumber(i, 'length', $event)" [attr.aria-label]="'Length for freight item ' + (i + 1)">
                  <input class="df-input min-w-0" type="number" min="0" step="any" placeholder="W" [class.df-input-invalid]="showValidation && hasIssue('freight_items.' + i + '.width')" [value]="manualLine(line).width ?? ''" (input)="updateLineNumber(i, 'width', $event)" [attr.aria-label]="'Width for freight item ' + (i + 1)">
                  <input class="df-input min-w-0" type="number" min="0" step="any" placeholder="H" [class.df-input-invalid]="showValidation && hasIssue('freight_items.' + i + '.height')" [value]="manualLine(line).height ?? ''" (input)="updateLineNumber(i, 'height', $event)" [attr.aria-label]="'Height for freight item ' + (i + 1)">
                </div>
                <select *ngIf="mode === 'edit'" class="df-input mt-1.5 w-full" [value]="manualLine(line).measurement_unit" (change)="updateMeasurementUnit(i, $event)" [attr.aria-label]="'Size unit for freight item ' + (i + 1)">
                  <option value="IN">Inches</option>
                  <option value="CM">Centimetres</option>
                </select>
                <span *ngIf="mode === 'rate'" class="font-semibold">
                  {{ manualLine(line).length ?? '—' }} &times; {{ manualLine(line).width ?? '—' }} &times; {{ manualLine(line).height ?? '—' }} {{ manualLine(line).measurement_unit }}
                </span>
              </ng-container>
              <ng-template #catalogSize>
                <span class="text-[11px] text-slate-500">From saved product</span>
              </ng-template>
            </td>

            <td class="px-3 py-3">
              <ng-container *ngIf="line.source === 'manual'; else catalogWeight">
                <div *ngIf="mode === 'edit'" class="grid grid-cols-[minmax(0,1fr)_4.5rem] gap-1.5">
                  <input class="df-input min-w-0" type="number" min="0" step="any" placeholder="Optional" [class.df-input-invalid]="showValidation && hasIssue('freight_items.' + i + '.weight')" [value]="manualLine(line).weight ?? ''" (input)="updateLineNumber(i, 'weight', $event)" [attr.aria-label]="'Weight for freight item ' + (i + 1)">
                  <select class="df-input" [value]="manualLine(line).weight_unit" (change)="updateWeightUnit(i, $event)" [attr.aria-label]="'Weight unit for freight item ' + (i + 1)">
                    <option value="LB">lb</option>
                    <option value="KG">kg</option>
                  </select>
                </div>
                <span *ngIf="mode === 'rate'" class="font-semibold">{{ manualLine(line).weight ?? '—' }} {{ manualLine(line).weight_unit }}</span>
              </ng-container>
              <ng-template #catalogWeight>
                <span class="text-[11px] text-slate-500">From saved product</span>
              </ng-template>
            </td>

            <td class="px-3 py-3">
              <label *ngIf="line.source === 'manual'" class="flex min-h-7 items-center gap-2 text-[11px] font-semibold text-slate-700">
                <input type="checkbox" [disabled]="mode === 'rate'" [checked]="manualLine(line).stackable" (change)="updateLineBoolean(i, 'stackable', $event)">
                Stackable
              </label>
              <label class="mt-1 flex min-h-7 items-center gap-2 text-[11px] font-semibold text-slate-700">
                <input type="checkbox" [disabled]="mode === 'rate'" [checked]="line.floor_rotation_allowed" (change)="updateLineBoolean(i, 'floor_rotation_allowed', $event)">
                Floor rotation
              </label>
            </td>

            <td *ngIf="mode === 'edit'" class="px-3 py-3 text-right">
              <button
                type="button"
                class="rounded-lg px-2 py-1.5 text-[11px] font-bold text-slate-500 transition hover:bg-rose-50 hover:text-rose-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-rose-500"
                (click)="removeLine(i)"
                [attr.aria-label]="'Remove freight item ' + (i + 1)"
              >
                Remove
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <section *ngIf="internalDraft.items.length > 0" class="rounded-xl border border-slate-200 bg-slate-50/70 p-3 sm:p-4" aria-labelledby="rating-inputs-heading">
      <div class="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h4 id="rating-inputs-heading" class="m-0 text-xs font-black text-slate-900">Shipment totals</h4>
          <p class="mb-0 mt-1 text-[11px] text-slate-500">Optional overrides when the item details do not tell the whole story.</p>
        </div>
      </div>

      <div class="mt-3 grid gap-3 sm:grid-cols-3">
        <label class="df-field">
          <span>Total weight (lb)</span>
          <input class="df-input" type="number" min="0" step="any" [disabled]="mode === 'rate'" [class.df-input-invalid]="showValidation && hasIssue('freight.total_weight_lb')" [value]="internalDraft.freight.total_weight_lb ?? ''" (input)="updateFreightNumber('total_weight_lb', $event)">
        </label>
        <label class="df-field">
          <span>Handling units</span>
          <input class="df-input" type="number" min="0" step="any" [disabled]="mode === 'rate'" [class.df-input-invalid]="showValidation && hasIssue('freight.handling_units')" [value]="internalDraft.freight.handling_units ?? ''" (input)="updateFreightNumber('handling_units', $event)">
        </label>
        <label class="df-field">
          <span>Linear feet</span>
          <input class="df-input" type="number" min="0" step="any" [disabled]="mode === 'rate'" [class.df-input-invalid]="showValidation && hasIssue('freight.linear_feet')" [value]="internalDraft.freight.linear_feet ?? ''" (input)="updateFreightNumber('linear_feet', $event)">
        </label>
      </div>

      <details class="mt-3 border-t border-slate-200 pt-3">
        <summary class="cursor-pointer text-xs font-bold text-slate-600 outline-none hover:text-blue-700 focus-visible:ring-2 focus-visible:ring-blue-500">
          More rating options
        </summary>
        <div class="mt-3 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          <label class="df-field"><span>Cubic feet</span><input class="df-input" type="number" min="0" step="any" [disabled]="mode === 'rate'" [class.df-input-invalid]="showValidation && hasIssue('freight.cubic_feet')" [value]="internalDraft.freight.cubic_feet ?? ''" (input)="updateFreightNumber('cubic_feet', $event)"></label>
          <label class="df-field"><span>Density (lb/cu ft)</span><input class="df-input" type="number" min="0" step="any" [disabled]="mode === 'rate'" [class.df-input-invalid]="showValidation && hasIssue('freight.density_lb_per_cuft')" [value]="internalDraft.freight.density_lb_per_cuft ?? ''" (input)="updateFreightNumber('density_lb_per_cuft', $event)"></label>
          <label class="df-field"><span>Delivery type</span><input class="df-input" type="number" min="0" step="1" [disabled]="mode === 'rate'" [class.df-input-invalid]="showValidation && hasIssue('freight.delivery_type')" [value]="internalDraft.freight.delivery_type ?? ''" (input)="updateFreightNumber('delivery_type', $event)"></label>
          <label class="df-field"><span>Rate method</span><select class="df-input" [disabled]="mode === 'rate'" [value]="activeRateMethod ?? ''" (change)="updateRateMethod($event)"><option value="">Best available</option><option value="1">Weight</option><option value="2">Linear feet</option><option value="3">Cubic weight</option><option value="4">Weight / cubic feet</option></select></label>
          <label class="df-field sm:col-span-2"><span>Load type</span><input class="df-input" type="text" [disabled]="mode === 'rate'" [value]="internalDraft.freight.load_type" (input)="updateLoadType($event)" placeholder="Optional"></label>
        </div>
      </details>
    </section>

    <div *ngIf="rateState === 'loading'" class="flex items-center gap-2 rounded-xl border border-blue-200 bg-blue-50 px-3 py-2.5 text-xs font-semibold text-blue-900" aria-live="polite">
      <span class="df-spinner" aria-hidden="true"></span>
      Finding the best customer rate&hellip;
    </div>

    <div *ngIf="rateState === 'error'" class="rounded-xl border border-rose-200 bg-rose-50 px-3 py-2.5 text-xs font-semibold text-rose-900" role="alert">
      {{ rateError || 'Unable to retrieve a customer rate.' }}
    </div>

    <section *ngIf="rateState === 'needs_input' && rateResponse" class="rounded-xl border border-amber-200 bg-amber-50 p-4 text-amber-950" aria-live="polite">
      <h4 class="m-0 text-sm font-black">The rate needs more information</h4>
      <p class="mb-0 mt-1 text-xs">Review the notes below, update the freight, and try again.</p>
      <ul *ngIf="rateResponse.warnings.length" class="mb-0 mt-2 space-y-1 pl-4 text-xs">
        <li *ngFor="let warning of rateResponse.warnings | slice:0:4">{{ warning }}</li>
      </ul>
    </section>

    <section *ngIf="rateState === 'rated' && rateResponse" class="rounded-xl border border-emerald-200 bg-emerald-50/70 p-4" aria-labelledby="customer-rate-heading" aria-live="polite">
      <div class="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h4 id="customer-rate-heading" class="m-0 text-xs font-black uppercase tracking-[0.12em] text-emerald-800">Customer rate</h4>
          <p class="mb-0 mt-1 text-2xl font-black tracking-tight text-emerald-950">{{ rateTotalLabel }}</p>
        </div>
        <div class="text-right text-xs text-emerald-900">
          <strong class="block">{{ rateMethodLabel }}</strong>
          <span *ngIf="rateResponse.meta.candidate_count">Best of {{ rateResponse.meta.candidate_count }} matches</span>
        </div>
      </div>

      <details class="mt-3 border-t border-emerald-200 pt-2 text-xs text-emerald-950">
        <summary class="cursor-pointer font-bold outline-none focus-visible:ring-2 focus-visible:ring-emerald-600">Rate details</summary>
        <dl class="mb-0 mt-2 grid gap-2 sm:grid-cols-2">
          <div><dt class="font-semibold text-emerald-700">Origin zone</dt><dd class="m-0 mt-0.5 font-bold">{{ originZoneLabel }}</dd></div>
          <div><dt class="font-semibold text-emerald-700">Destination zone</dt><dd class="m-0 mt-0.5 font-bold">{{ destinationZoneLabel }}</dd></div>
        </dl>
        <ul *ngIf="rateResponse.warnings.length" class="mb-0 mt-2 space-y-1 pl-4 text-amber-900">
          <li *ngFor="let warning of rateResponse.warnings | slice:0:3">{{ warning }}</li>
        </ul>
      </details>
    </section>

    <div class="-mx-4 -mb-4 flex flex-col gap-3 border-t border-slate-200 bg-white px-4 py-3 sm:-mx-5 sm:-mb-5 sm:flex-row sm:items-center sm:justify-between sm:px-5">
      <p class="m-0 text-xs font-semibold" [class.text-emerald-700]="readyForRating" [class.text-slate-500]="!readyForRating">
        {{ ratingReadinessMessage }}
      </p>
      <button
        type="button"
        class="min-h-11 shrink-0 rounded-lg bg-blue-600 px-5 py-2.5 text-sm font-black text-white shadow-sm transition hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 disabled:cursor-wait disabled:bg-blue-300"
        [disabled]="rateState === 'loading'"
        (click)="prepareRateRequest()"
      >
        {{ rateState === 'loading' ? 'Getting customer rate…' : (rateState === 'rated' ? 'Update customer rate' : 'Get customer rate') }}
      </button>
    </div>

    <div *ngIf="showValidation && validationIssues.length > 0" class="rounded-xl border border-rose-200 bg-rose-50 px-3 py-2.5 text-xs text-rose-900" role="alert">
      <strong class="block">A few details still need attention:</strong>
      <ul class="mb-0 mt-1 space-y-0.5 pl-4">
        <li *ngFor="let issue of validationIssues | slice:0:4">{{ issue.message }}</li>
        <li *ngIf="validationIssues.length > 4">{{ validationIssues.length - 4 }} more</li>
      </ul>
    </div>
  </div>
</section>
